<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_packageType') || '包装类型'"
          >
            <dict-select
              v-model="formData.packageType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'packageType' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
              disabled
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_detail_material_category') || '2级物料分类'
            "
            prop="detailMaterialCategoryCode"
            ref="detailMaterialForm"
          >
            <dict-select
              size="small"
              clearable
              filterable
              v-model="formData.detailMaterialCategoryCode"
              :body="detailMaterialParams"
              :disabled="
                formData.mainMaterialCategoryCode == null ||
                  formData.mainMaterialCategoryCode == ''
              "
              @change="updateMaterial"
              url="/master/material/category/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('INDEX.order_package_materialNo') || '包装编号'"
            ref="material"
            prop="materialNo"
          >
            <el-input clearable v-model="formData.materialNo" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="addMaterial"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_materialName') || '物料名称'"
            prop="materialName"
          >
            <el-input v-model="formData.materialName" readonly :size="'small'">
            </el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_materialSpec') || '辅料规格'"
            prop="materialSpec"
          >
            <el-input v-model="formData.materialSpec" :size="'small'">
            </el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_package_boxLength') || '包装箱长(cm)'"
            prop="boxLength"
          >
            <el-input-number
              v-model="formData.boxLength"
              style="width:100%"
              :min="0"
              :precision="2"
              :step="1"
              controls-position="right"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_package_boxWidth') || '包装箱宽(cm)'"
            prop="boxWidth"
          >
            <el-input-number
              v-model="formData.boxWidth"
              style="width:100%"
              :min="0"
              :precision="2"
              :step="1"
              controls-position="right"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_package_boxHeight') || '包装箱高(cm)'"
            prop="boxHeight"
          >
            <el-input-number
              v-model="formData.boxHeight"
              style="width:100%"
              :min="0"
              :precision="2"
              :step="1"
              controls-position="right"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_package_boxWeight') || '包装箱重量(g)'"
            prop="boxWeight"
          >
            <el-input-number
              v-model="formData.boxWeight"
              style="width:100%"
              :min="0"
              :precision="0"
              :step="1"
              controls-position="right"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_isSpecify') || '客户指定供应商'"
            ><br />
            <el-radio-group size="small" v-model="formData.isSpecify">
              <el-radio label="Y">
                {{ this.$l('INDEX.YES') || '是' }}
              </el-radio>
              <el-radio label="N">
                {{ this.$l('INDEX.NO') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
          >
            <dict-select
              size="small"
              clearable
              :disabled="this.formData.isSpecify === 'N'"
              filterable
              v-model="formData.scmCode"
              url="/master/common/dict/scm"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_isCustomerProvide') || '客户指定供应商'
            "
            ><br />
            <el-radio-group size="small" v-model="formData.isCustomerProvide">
              <el-radio label="Y">
                {{
                  this.$l('INDEX.order_form_label_isCustomerProvide_Y') || '是'
                }}
              </el-radio>
              <el-radio label="N">
                {{
                  this.$l('INDEX.order_form_label_isCustomerProvide_N') || '否'
                }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>

    <choose-material-dialog
      :title="$l('INDEX.material_choose_title') || '添加物料信息'"
      :visible.sync="visible"
      :productLine="formData.productLine"
      :detailMaterialCategoryCode="formData.detailMaterialCategoryCode"
      :mainMaterialCategoryCode="formData.mainMaterialCategoryCode"
      type="radio"
      @confirm="onMaterialConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    changeOrderCode:{ type: String, default: '' },
    code: { type: String, default: '' },
    isCopy: Boolean,
  },
  watch: {},
  data() {
    return {
      backDialogVisible: false,
      visible: false,
      proofingTypeParams: { dictType: 'proofingType' },
      productLineParams: { dictType: 'productLine' },
      mainMaterialParams: {},
      detailMaterialParams: {
        parentCode: 'd24ddeab-5ee4-41b2-bcc5-b3f3524a83a3',
      },
      formData: {
        isSpecify: 'N',
        isCustomerProvide: 'N',
        productLine: 'ABSHome',
        mainMaterialCategoryCode: 'd24ddeab-5ee4-41b2-bcc5-b3f3524a83a3',
        packageType: 'outPackage',
        materialNo: '',
        materialCode: '',
      },
      rules: {
        materialNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_package_no') ||
              '请选择包装编号',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .changeOrdeDemandPackageDetailApi({
          changeOrderPackageCode: this.code,
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.formData = res.body
          if (this.isCopy) {
            this.formData.changeOrderPackageCode = ''
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      this.loadingOpen()
      let saveApi

      if (this.code) {
        saveApi = this.$api.changeOrdeDemandPackageModifyApi
      } else {
        saveApi = this.$api.changeOrdeDemandPackageAddApi
      }

      saveApi({
        ...this.formData,
        changeOrderCode: this.changeOrderCode,
      })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    addMaterial() {
      const { detailMaterialCategoryCode } = this.formData
      if (!detailMaterialCategoryCode) {
        this.$message.warning(
          this.$l('INDEX.pe_select_Level_2_material_classification') ||
            '请选择2级物料分类'
        )
        return
      }
      this.visible = true
    },
    goodsSpecDialogClose() {
      this.visible = false
    },
    confirm(params) {
      const { orderGoodsCode, orderGoodsNo, orderGoodsDisplayName } = params
      this.formData.orderGoodsCode = orderGoodsCode
      this.formData.orderGoodsNo = orderGoodsNo
      this.formData.orderGoodsDisplayName = orderGoodsDisplayName
    },
    updateMaterial() {
      this.formData.materialCode = ''
      this.formData.materialNo = ''
      this.formData.materialName = ''
      this.formData.materialSpec = ''
      this.formData.materialDisplayName = ''
    },
    onMaterialConfirm(data) {
      if (!data) return
      console.log(data)
      this.formData.materialCode = data.materialCode
      this.formData.materialNo = data.materialNo
      this.formData.materialName = data.materialName
      this.formData.materialDisplayName = data.materialNameEn
      this.formData.scmCode = data.scmCode
      this.formData.materialSpec = ''
    },
  },
}
</script>
